import IpsTooltip from './IpsTooltip.vue';
import '../../../styles/custom.scss';

export default IpsTooltip;
